import { myApi } from '../../config/axiosConfig';

// =========================================
// FUNCION PARA OBTENER UNIDADES EN IDLE ACTIVAS
// =========================================

export const getIdleActivas = async () => {

    const response = await myApi.get('/idle/events/active');

    return response.data;

}

// =========================================
// FUNCION PARA OBTENER UNIDADES EN IDLE HISTORIAL
// =========================================

export const getIdleHistorial = async () => {

    const response = await myApi.get('/idle/events/historial');

    return response.data;

}